import React, { useEffect, useMemo, useState } from "react";
import AdminAppBar from "../../adminComponents/AdminAppBar";
import CreateNewSpinWheelButton from "./CreateNewSpinWheelButton";
import { useLocation, useNavigate } from "react-router-dom";
import Modal from "react-modal";
import SpinWheelDetail from "./SpinWheelDetail";
import SpinWheelService from "../../Services/SpinWheelService";
import { showSuccessToast, showErrorToast } from "../../Constant/Notification";
import { ToastContainer } from "react-toastify";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import CustomHeading from "../../common/CustomHeading";

const SpinWheel = () => {
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    if (location.state?.message) {
      showSuccessToast(location.state.message);
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location, navigate]);
  const [spinwheelDetail, setSpinwheelDetail] = useState([]);
  const [logo, setLogo] = useState();
  const [termsAndCondition, setTermsAndCondition] = useState();
  const userData = JSON.parse(localStorage.getItem("userData"));
  const userRole = userData?.user?.role || "";
  const [editButton, setEditButton] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isTermAndConditionModalOpen, setIsTermAndConditionModalOpen] =
    useState(false);

  const [logoUploadLoading, setLogoUploadLoading] = useState(false);
  const [logoSaveLoading, setLogoSaveLoading] = useState(false);

  const handleSpinWheelOne = () => {
    if (userRole == "Admin") {
      navigate("/admin/spin-wheel-creation");
    } else if (userRole == "CMO") {
      navigate("/cmo/spin-wheel-creation");
    }
  };

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "40%",
      padding: "24px",
      position: "relative",
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.75)",
    },
  };

  Modal.setAppElement("#root");

  const handleCloseTermsAndConditionModal = () => {
    setIsTermAndConditionModalOpen(false);
  };
  const handleOpenTermsAndContionModal = async () => {
    try {
      const response = await SpinWheelService.getSpinWheelGeneralInfo();
      console.log(response.data);

      if (response?.data) {
        setTermsAndCondition(response.data.termsAndCondition);
      }
    } catch (error) {
      console.log(error.response.data);
    }
  };
  const handleOpenWheelLogoUploadModal = async () => {
    try {
      const response = await SpinWheelService.getSpinWheelGeneralInfo();
      console.log(response.data);
      setLogo(response.data.spinWheelLogo);
      setIsModalOpen(true);
    } catch (error) {
      console.log(error.response.data);
    }
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await SpinWheelService.getSpinWheelDetail();
        setSpinwheelDetail(response.data);
      } catch (error) {
        console.error(error.response.data);
      }
    };
    fetchData();
  }, []);

  const handleSpinWheelLogoUpload = async (file) => {
    if (!file) return;

    const allowedTypes = [
      "image/png",
      "image/jpeg",
      "image/jpg",
      "image/webp",
      "image/svg+xml",
    ];
    if (!allowedTypes.includes(file.type)) {
      showErrorToast(
        "Please upload a valid image file (PNG, JPG, JPEG, WebP, or SVG)"
      );
      return;
    }

    const maxSizeMB = 1;
    if (file.size > maxSizeMB * 1024 * 1024) {
      showErrorToast("Image must be less than 1MB");
      return;
    }

    setLogoUploadLoading(true);
    try {
      const formData = new FormData();
      formData.append("file", file);
      const folderPath = "spinWheelLogo";
      const response = await SpinWheelService.createBannerImageTemplate(
        formData,
        folderPath
      );
      const imageUrl = response.data.imageUrl;
      setLogo(imageUrl);
      showSuccessToast("Logo uploaded successfully!");
    } catch (error) {
      console.log(error.response?.data);
      showErrorToast("Failed to upload logo. Please try again.");
    } finally {
      setLogoUploadLoading(false);
    }
  };

  const handleSetWheelLogo = async () => {
    if (!logo) {
      showErrorToast("Please upload a logo first");
      return;
    }

    setLogoSaveLoading(true);
    try {
      const response = await SpinWheelService.setSpinWheelLogo({
        spinWheelLogo: logo,
      });
      console.log(response.data);
      setIsModalOpen(false);
      showSuccessToast("Wheel logo saved successfully!");
    } catch (error) {
      console.log(error.response?.data);
      showErrorToast("Failed to save logo. Please try again.");
    } finally {
      setLogoSaveLoading(false);
    }
  };

  const handleSetTermsAndCondition = async () => {
    try {
      const response = await SpinWheelService.setSpinWheelLogo({
        termsAndCondition: termsAndCondition,
      });
      console.log(response.data);
      setIsTermAndConditionModalOpen(false);
    } catch (error) {
      console.log(error.response.data);
    }
  };

  const toolbarOptions = useMemo(
    () => [
      ["bold", "italic", "underline", "strike"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["clean"],
    ],
    []
  );

  const module = useMemo(
    () => ({
      toolbar: {
        container: toolbarOptions,
      },
    }),
    [toolbarOptions]
  );
  return (
    <div className="bg-appGrayBackground">
      <AdminAppBar />
      <ToastContainer />
      <div className="pt-16">
        <div className="mt-10 px-20 xl:px-6 relative flex justify-between gap-5">
          <div>
            <CustomHeading title="Spin wheel" isIcon={true} />
          </div>

          <div className="flex gap-5">
            <button
              onClick={() => {
                handleOpenTermsAndContionModal();
                setIsTermAndConditionModalOpen(true);
              }}
              className="border-2 whitespace-nowrap border-customGreen rounded-sm p-1 px-5 w-fit text-lg text-customGreen h-10 text-center"
            >
              Terms and Condition
            </button>

            <button
              onClick={() => {
                handleOpenWheelLogoUploadModal();
                setIsModalOpen(true);
              }}
              className="border-2 whitespace-nowrap border-customGreen rounded-sm p-1 px-5 w-fit text-lg text-customGreen h-10 text-center"
            >
              Upload Wheel logo
            </button>
          </div>
        </div>

        <div className="mx-8 flex-col flex gap-8 mt-10">
          {Array.from({ length: 4 }).map((_, index) =>
            index < spinwheelDetail.length ? (
              <SpinWheelDetail
                key={`spinwheel-${index}`}
                spinWheelData={spinwheelDetail[index]}
              />
            ) : (
              <CreateNewSpinWheelButton
                onclick={handleSpinWheelOne}
                key={`button-${index}`}
              />
            )
          )}
        </div>
      </div>

      <Modal
        isOpen={isModalOpen}
        onRequestClose={handleCloseModal}
        contentLabel="Wheel logo"
        style={customStyles}
      >
        <button
          onClick={handleCloseModal}
          className="absolute top-5 right-3 text-2xl text-gray-700 hover:text-red-500 transition-colors"
        >
          &times;
        </button>
        <div className="flex justify-between items-center">
          <h2 className="text-3xl font-semibold mb-4">Wheel Logo</h2>
          <button
            onClick={handleSetWheelLogo}
            disabled={logoSaveLoading || !logo || logoUploadLoading}
            className={`text-white w-20 h-10 mr-5 rounded-lg text-center transition-all ${
              logoSaveLoading || logoUploadLoading || !logo
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-customGreen hover:bg-green-600"
            }`}
          >
            {logoSaveLoading || logoUploadLoading ? (
              <div className="flex justify-center items-center">
               Save
              </div>
            ) : (
              "Save"
            )}
          </button>
        </div>

        <input
          id="fileInput"
          type="file"
          className="hidden"
          accept="image/png,image/jpeg,image/jpg,image/webp,image/svg+xml"
          onChange={(e) => handleSpinWheelLogoUpload(e.target.files[0])}
          disabled={logoUploadLoading}
        />
        <label
          htmlFor="fileInput"
          className={`w-full min-h-[200px] flex items-center justify-center border-2 border-dashed border-gray-300 bg-appGrayBackground rounded-lg cursor-pointer hover:border-customGreen transition-colors relative ${
            logoUploadLoading ? "opacity-50 cursor-not-allowed" : ""
          }`}
        >
          {logoUploadLoading ? (
            <div className="flex flex-col items-center gap-2">
              <div className="animate-spin rounded-full h-8 w-8 border-2 border-customGreen border-t-transparent"></div>
              <span className="text-sm text-gray-600">Uploading...</span>
            </div>
          ) : logo ? (
            <div className="relative w-full h-full min-h-[180px] flex items-center justify-center">
              <img
                src={logo}
               
                className="max-w-full max-h-full object-contain rounded-lg"
              />
              <div className="absolute inset-0  bg-opacity-0 hover:bg-opacity-10 transition-all rounded-lg flex items-center justify-center">
                <span className="text-white opacity-0 hover:opacity-100 transition-opacity bg-black bg-opacity-50 px-3 py-1 rounded">
                  Click to change
                </span>
              </div>
            </div>
          ) : (
            <div className="text-center">
              <div className="mb-2">
                <svg
                  className="mx-auto h-12 w-12 text-gray-400"
                  stroke="currentColor"
                  fill="none"
                  viewBox="0 0 48 48"
                >
                  <path
                    d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <p className="text-gray-600 mb-1">Click here to upload logo</p>
              <p className="text-xs text-gray-500">
                PNG, JPG, JPEG, WebP, SVG (Max: 1MB)
              </p>
              <p className="text-xs text-gray-400 mt-1">
                Square images work best
              </p>
            </div>
          )}
        </label>
      </Modal>

      <Modal
        isOpen={isTermAndConditionModalOpen}
        onRequestClose={handleCloseTermsAndConditionModal}
        contentLabel="Terms and Conditions"
        style={customStyles}
      >
        <button
          onClick={handleCloseTermsAndConditionModal}
          className="absolute top-5 right-3 text-2xl text-gray-700"
        >
          &times;
        </button>
        <div className="flex justify-between">
          <h2 className="text-3xl font-semibold mb-4">Terms & Conditions</h2>

          {editButton ? (
            <>
              <div>
                <button
                  onClick={() => setEditButton(false)}
                  className="text-customGreen bg-transparent border-2 border-customGreen w-20 h-10 mr-5 rounded-lg text-center"
                >
                  Cancel
                </button>
                <button
                  onClick={handleSetTermsAndCondition}
                  className="text-white bg-customGreen w-20 h-10 mr-5 rounded-lg text-center"
                >
                  Save
                </button>
              </div>
            </>
          ) : (
            <button
              onClick={() => setEditButton(true)}
              className="text-white bg-customGreen w-20 h-10 mr-5 rounded-lg text-center"
            >
              Edit
            </button>
          )}
        </div>

        {editButton ? (
          <ReactQuill
            value={termsAndCondition}
            modules={module}
            onChange={setTermsAndCondition}
            className="focus:outline-none bg-[#F6F6F6] w-full h-[300px] p-2 rounded-xl border-none"
          />
        ) : (
          <ReactQuill
            value={termsAndCondition}
            readOnly
            modules={module}
            className="focus:outline-none bg-[#F6F6F6] w-full  p-2 rounded-xl border-none"
          />
        )}
      </Modal>
    </div>
  );
};

export default SpinWheel;
